export default __webpack_public_path__ + "static/media/FortisHeader1.046f1831.png";